import React, { FC } from 'react';
import cn from 'classnames';
import { useLandingPageContext } from 'context/LandingPageContext';
import styles from './HelloBar.module.scss';

export interface HelloBarProps {
  text: string;
  backgroundColor: string;
  textColor: string;
  layout: string;
}

const HelloBar: FC<HelloBarProps> = ({ text: __html, backgroundColor, textColor: color, layout }) => {
  const { theme } = useLandingPageContext();

  return (
    <div
      style={{ backgroundColor, color }}
      className={cn(styles.container, styles[`theme-${theme}`], { [styles.containerWide]: layout === 'wide' })}
    >
      <div dangerouslySetInnerHTML={{ __html }} />
    </div>
  );
};

export default HelloBar;
